export const OFFICE_POSITION = [52.6369, -1.1398];

export const serviceAreas = [
  {
    name: 'Leicester',
    position: OFFICE_POSITION,
    isOffice: true,
    address: '4 Rivers Street, Leicester, LE3 5RX',
  },
  { name: 'Birstall', position: [52.6725, -1.1147] },
  { name: 'Rothley', position: [52.7119, -1.1351] },
  { name: 'Melton Mowbray', position: [52.7657, -0.8862] },
  { name: 'Loughborough', position: [52.7721, -1.207] },
  { name: 'Thurmaston', position: [52.6762, -1.1041] },
  { name: 'Mountsorrel', position: [52.7036, -1.1298] },
];

export function milesFromOffice([lat, lng]) {
  const earthRadiusMiles = 3958.8;
  const [officeLat, officeLng] = OFFICE_POSITION;
  const toRad = (deg) => (deg * Math.PI) / 180;

  const dLat = toRad(lat - officeLat);
  const dLng = toRad(lng - officeLng);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(officeLat)) * Math.cos(toRad(lat)) * Math.sin(dLng / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return earthRadiusMiles * c;
}
